import React from "react";
import "../css/NasilCalisir.css";

const HowItWorks = () => {
  return (
    <div className="nasilCalisir">
      <p className="nasilCalisirBaslik">Avukatımol, Nasıl Çalışıyor?</p>
      <div className="nasilCalisirContainer">
        <div className="nasilCalisirFirstDiv">
          <div className="nasilCalisirFirstDivP">
            <p>1</p>
          </div>
          <div className="nasilCalisirh1">
            <div className="ucgen"></div>
            <h1 className="mt-4">
              Avukat <br /> Bulun
            </h1>
            <h3>
              100.000'den fazla avukat arasından seçim yapın. Diğer insanların
              görüşlerini inceleyin.
            </h3>

            <svg
              className="nasilCalisirsvg1 "
              xmlns="http://www.w3.org/2000/svg"
              width="63"
              height="63"
              viewBox="0 0 47.024 47.032"
              fill="currentColor"
            >
              <path
                id="Icon_awesome-search"
                data-name="Icon awesome-search"
                d="M46.385,40.662,37.227,31.5a2.2,2.2,0,0,0-1.561-.643h-1.5a19.1,19.1,0,1,0-3.307,3.307v1.5a2.2,2.2,0,0,0,.643,1.561l9.158,9.158a2.2,2.2,0,0,0,3.114,0l2.6-2.6a2.215,2.215,0,0,0,.009-3.123Zm-27.28-9.8A11.757,11.757,0,1,1,30.862,19.1,11.75,11.75,0,0,1,19.1,30.862Z"
                fill="#00242e"
                opacity="0.75"
              />
            </svg>
          </div>
        </div>
        <div
          className="nasilCalisirFirstDiv"
          style={{ border: "2px solid #00242E" }}
        >
          <div
            className="nasilCalisirFirstDivP "
            style={{ backgroundColor: "#00242E" }}
          >
            <p>2</p>
          </div>
          <div className="nasilCalisirh1">
            <div className="ucgen ucgen2"></div>
            <h1 className="mt-4">
              Hemen <br /> Randevu <br /> Alın
            </h1>
            <h3>
              Size uygun tarih ve saati seçin, bilgilerinizi girin ve onaylayın.
              Müsait olan avukatlar ile online görüşün.
            </h3>
            <svg
              className="nasilCalisirsvg2 "
              xmlns="http://www.w3.org/2000/svg"
              width="63"
              height="63"
              viewBox="0 0 40.476 46.258"
              fill="currentColor"
            >
              <path
                id="Icon_awesome-calendar-check"
                data-name="Icon awesome-calendar-check"
                d="M39.392,14.456H1.084A1.084,1.084,0,0,1,0,13.372V10.119A4.337,4.337,0,0,1,4.337,5.782H8.673v-4.7A1.084,1.084,0,0,1,9.758,0h3.614a1.084,1.084,0,0,1,1.084,1.084v4.7H26.02v-4.7A1.084,1.084,0,0,1,27.1,0h3.614A1.084,1.084,0,0,1,31.8,1.084v4.7h4.337a4.337,4.337,0,0,1,4.337,4.337v3.253A1.084,1.084,0,0,1,39.392,14.456ZM1.084,17.347H39.392a1.084,1.084,0,0,1,1.084,1.084V41.922a4.337,4.337,0,0,1-4.337,4.337H4.337A4.337,4.337,0,0,1,0,41.922V18.431A1.084,1.084,0,0,1,1.084,17.347ZM31.2,26.016,28.652,23.45a1.084,1.084,0,0,0-1.533-.006l-9.58,9.5-4.154-4.188a1.084,1.084,0,0,0-1.533-.006L9.285,31.3a1.084,1.084,0,0,0-.006,1.533l7.463,7.523a1.084,1.084,0,0,0,1.533.006L31.191,27.549a1.084,1.084,0,0,0,.006-1.533Z"
                fill="#00242e"
                opacity="0.75"
              />
            </svg>
          </div>
        </div>
        <div className="nasilCalisirFirstDiv">
          <div className="nasilCalisirFirstDivP">
            <p>3</p>
          </div>
          <div className="nasilCalisirh1">
            <div className="ucgen"></div>
            <h1 className="mt-4">
              Randevu <br /> Oluşturmak <br /> Ücretsizdir
            </h1>
            <h3>
              Avukatımol'da randevu oluşturmak tamamen ücretsizdir. (Danışma
              ücretlerini öğrenmek için avukatınıza başvurun)
            </h3>
            <svg
              className="nasilCalisirsvg3 "
              xmlns="http://www.w3.org/2000/svg"
              width="63"
              height="63"
              fill="currentColor"
            >
              <path
                id="Path_26"
                data-name="Path 26"
                d="M641.9,10.6H622.6l-22,22.8a5.191,5.191,0,0,0,0,7.3h0l15,15a5.823,5.823,0,0,0,3.5,1.5,6.41,6.41,0,0,0,3.8-1.5l22.8-21.8V14.5ZM627.3,40.2a7.386,7.386,0,0,1-5.5,2.1H619V34.4l-3.4,1.4V33.6l3.4-1.4V30.3l-3.4,1.4V29.5l3.4-1.4V21.7h2.4v5.5l4.9-2v2.2l-4.9,2v1.9l4.9-2v2.2l-4.9,1.9v6.7h.5a5.046,5.046,0,0,0,3.8-1.5,6.163,6.163,0,0,0,1.6-4.2h2.4A8.838,8.838,0,0,1,627.3,40.2Zm13.5-19.7a3.974,3.974,0,0,1-2.6,2.6,4.027,4.027,0,0,1-4.9-2.6,3.9,3.9,0,0,1,2.6-4.9,4.027,4.027,0,0,1,4.9,2.6A4.479,4.479,0,0,1,640.8,20.5Z"
                transform="translate(-599.1 -10.6)"
                fill="#00242e"
                opacity="0.75"
              />
            </svg>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HowItWorks;
